(() => {
  const KEY='vq-buyer-choice-v2';
  const PERIOD=30*24*60*60*1000;
  function remember(kind){
    const saved={kind,expires:Date.now()+PERIOD};
    try{localStorage.setItem(KEY,JSON.stringify(saved));}catch{}
    document.cookie=`vq_buyer_choice_v2=${kind}; Max-Age=${PERIOD/1000}; Path=/; SameSite=Lax; Secure`;
  }
  function remembered(){
    try{const saved=JSON.parse(localStorage.getItem(KEY));if(saved&&saved.expires>Date.now()&&['wholesale','retail','dismissed'].includes(saved.kind))return true;}catch{}
    return /(?:^|;\s*)vq_buyer_choice_v2=(?:wholesale|retail|dismissed)(?:;|$)/.test(document.cookie);
  }
  if(customElements.get('vq-wholesale-popup'))return;
  customElements.define('vq-wholesale-popup',class extends HTMLElement{
    connectedCallback(){
      if(this.abort||/(?:^|\/)challenge\/?$/.test(location.pathname))return;
      this.abort=new AbortController();const signal=this.abort.signal;
      this.dialog=this.querySelector('dialog');this.launch=this.querySelector('[data-wpop-launch]');
      this.reservePreviewBar();
      this.addEventListener('click',event=>{
        const choice=event.target.closest('[data-wpop-choice]');
        if(choice){remember(choice.dataset.wpopChoice);this.dialog.close();return;}
        if(event.target.closest('[data-wpop-launch]'))this.show();
        if(event.target.closest('[data-wpop-close]')||event.target===this.dialog){remember('dismissed');this.dialog.close();}
      },{signal});
      this.dialog.addEventListener('cancel',()=>remember('dismissed'),{signal});
      this.dialog.addEventListener('close',()=>{document.documentElement.classList.remove('vq-wpop-locked');this.launch.focus({preventScroll:true});},{signal});
      if(!remembered()&&this.dataset.autoOpen==='true'&&this.dataset.designMode!=='true'){
        let attempts=0;const invite=()=>{
          if(!this.isConnected||remembered())return;
          if(document.hidden||document.querySelector('dialog[open]')){if(++attempts<20)this.timer=setTimeout(invite,1000);return;}
          this.show();
        };this.timer=setTimeout(invite,600);
      }
    }
    show(){clearTimeout(this.timer);if(this.dialog.open)return;this.dialog.showModal();document.documentElement.classList.add('vq-wpop-locked');}
    reservePreviewBar(){
      let tries=0;
      const attach=()=>{
        if(!this.isConnected)return;
        const bar=document.getElementById('PBarNextFrame');
        if(!bar){if(++tries<20)this.previewTimer=setTimeout(attach,500);return;}
        const adjust=()=>{const r=bar.getBoundingClientRect();this.style.setProperty('--wpop-preview-bottom',`${r.height>0?(r.height>=160?64:r.height):0}px`);};
        this.previewObserver=new ResizeObserver(adjust);this.previewObserver.observe(bar);adjust();
      };attach();
    }
    disconnectedCallback(){clearTimeout(this.timer);clearTimeout(this.previewTimer);this.previewObserver?.disconnect();this.abort?.abort();this.abort=null;if(this.dialog?.open)document.documentElement.classList.remove('vq-wpop-locked');}
  });
})();
